import React, { lazy, Suspense } from 'react';
import { withScreenSize } from '../common/utilities/withScreenSize.jsx';
import { IStoreState } from '../common/interfaces/types';
import { reduxConnect } from '../../common';

const LazyLoadSmartAppBannerV1 = lazy(() => import('./smartAppBanner'));

interface SmartAppBannerLazyLoadProps {
    isDesktop: boolean;
    isBot: boolean;
    enableNewSmartBanner: boolean;
}

const mapStoreStateToProps = (storeState: IStoreState) => {
    const appState = storeState.appState.appState || {};
    const { user, enableNewSmartBanner } = appState || {};

    return {
        isBot: user?.IsBot,
        enableNewSmartBanner
    };
};

const mapDispatchToProps = {
};

export const SmartAppBannerLazyLoaderV1 = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(withScreenSize(({
    isDesktop,
    isBot,
    enableNewSmartBanner
}: SmartAppBannerLazyLoadProps) => {

    if (isBot || isDesktop || enableNewSmartBanner) {
        return null;
    }

    return (
        <Suspense fallback={<span></span>}>
            <LazyLoadSmartAppBannerV1 />
        </Suspense>
    );
}));